/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Product_Total_CountInputs */

const vi_product_total_count = /** @type {(inputs: Product_Total_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tổng ${i?.count} sản phẩm`)
};

/**

* @param {Product_Total_CountInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_total_count = /** @type {((inputs: Product_Total_CountInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Total_CountInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_total_count(inputs)
});